import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteRequirementQuestion } from 'api/requirements/deleteRequirementQuestion'
import { requirementKeys } from './keys'

type Response = Awaited<ReturnType<typeof deleteRequirementQuestion>>
type Variables = Omit<
  Parameters<typeof deleteRequirementQuestion>[0],
  'requirementId'
>

export const useDeleteRequirementQuestionMutation = (requirementId: number) => {
  const queryClient = useQueryClient()

  return useMutation<Response, Error, Variables>({
    mutationFn: ({ questionId }) =>
      deleteRequirementQuestion({ requirementId, questionId }),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: requirementKeys.detail(requirementId),
      })
    },
  })
}
